import { useQuery } from "@tanstack/react-query";
import { statsRepo } from "@/lib/repositories";
import type { PublishedDilemmasStatParams } from "../types";

export function useFetchPublishedDilemmas({
  end_date,
  start_date,
  status,
  x_period,
}: PublishedDilemmasStatParams) {
  const query = useQuery({
    queryKey: [
      "stats",
      "published-dilemmas",
      { end_date, start_date, status, x_period },
    ],
    queryFn: () =>
      statsRepo.fetchPublishedDilemmas({
        end_date,
        start_date,
        status,
        x_period,
      }),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
}
